import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";

function SelectCompany() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axiosInstance.get("/auth/companies");
        setCompanies(res.data.companies || []);
        if (res.data.activeCompanyId && (res.data.companies?.length || 0) <= 1) {
          navigate("/report");
        }
      } catch (e) {
        setError(e.response?.data?.message || "Failed to load companies");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [navigate]);

  const selectCompany = async (companyId) => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.post("/auth/switch-company", { companyId });
      localStorage.setItem("token", res.data.accessToken);
      localStorage.setItem("refreshToken", res.data.refreshToken);
      window.dispatchEvent(new Event("tokenUpdated"));
      navigate("/report");
    } catch (e) {
      setError(e.response?.data?.message || "Failed to select company");
    } finally {
      setLoading(false);
    }
  };

  if (loading && companies.length === 0) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <p>Loading companies...</p>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center min-h-screen p-4">
      <div className="w-full max-w-md bg-white p-6 rounded shadow-md space-y-4">
        <h2 className="text-2xl font-bold">Select company</h2>
        <p className="text-gray-600 text-sm">
          Choose which company you want to work in. You can switch later from the top bar.
        </p>
        {error && <div className="text-red-500">{error}</div>}
        <ul className="divide-y border rounded">
          {companies.map((c) => (
            <li key={c._id}>
              <button
                type="button"
                onClick={() => selectCompany(c._id)}
                className="w-full text-left px-4 py-3 hover:bg-gray-50"
                disabled={loading}
              >
                <div className="font-medium">{c.name}</div>
                {c.customerName && (
                  <div className="text-xs text-gray-500">{c.customerName}</div>
                )}
              </button>
            </li>
          ))}
        </ul>
        {companies.length === 0 && (
          <p className="text-gray-500">No companies available for your account.</p>
        )}
      </div>
    </div>
  );
}

export default SelectCompany;
